import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { name: '剧情解析', path: '/category/plot-analysis' },
      { name: '角色介绍', path: '/category/characters' },
      { name: '声优阵容', path: '/category/voice-actors' },
      { name: 'OVA特辑', path: '/category/ova' },
      { name: '名场面回顾', path: '/category/iconic-scenes' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '联系方式', path: '/about#contact' },
      { name: '品牌介绍', path: '/about#brand' },
      { name: '隐私政策', path: '/about#privacy' },
    ],
  },
  {
    title: '推荐内容',
    links: [
      { name: '住之江亚香', path: '/article/ako-character-deep-dive' },
      { name: '住之江理香', path: '/article/riko-character-guide' },
      { name: '住之江圭太', path: '/article/keita-character-analysis' },
      { name: '恋爱动漫推荐', path: '/article/kissxsis-anime-recommendation' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="text-xl font-heading text-primary-500 font-bold">亲吻姐姐</span>
                <span className="block text-xs text-foreground-500 font-body mt-1">经典恋爱动漫官方解析站</span>
              </Link>
              <p className="text-sm text-foreground-600 font-body leading-relaxed">
                致力于为亲吻姐姐粉丝提供最全面、最深度的动漫内容解析与社区交流平台。从剧情分析到角色解读，从声优揭秘到名场面回顾，带你重新发现这部经典作品的魅力。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-heading font-bold text-foreground-900 mb-4">{group.title}</h4>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-500 font-body transition-colors duration-200"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 font-body">
              &copy; 2026 亲吻姐姐官方解析站. 本站为粉丝自制内容站点，与官方动画制作方无关。
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}